<template>
  <div class="application-form qualification-step">
    <Qualifications :profile="profile" :requestGraduationDate="false" :withComponents="false" />

    <v-btn :color="themes.candidate.light.primaryActionButton" @click="$emit('input')" block>
      Save
    </v-btn>
  </div>
</template>

<script>
import Qualifications from '@/components/candidate/profile/edit/qualifications/Qualifications'

export default {
  components: { Qualifications },
  props: { profile: { type: Object, required: true } },
}
</script>
